/**
 * Number Showcase Page
 *
 * This page demonstrates number input types available in the RUL form system.
 *
 * Route: /apps/examples/forms/number-showcase
 */

import { message } from 'antd';
import { UniversalRULForm } from '@/components/features/rul/UniversalRULForm';
import './NumberShowcasePage.css';

export const NumberShowcasePage: React.FC = () => {
  const handleSuccess = (data: any) => {
    message.success('Form validated successfully!');
    console.log('Form submitted:', data);
  };

  const handleError = (errors: Record<string, string>) => {
    message.error('Please fix validation errors');
    console.error('Validation errors:', errors);
  };

  return (
    <div className="number-showcase-page">
      <div className="number-showcase-container">
        <UniversalRULForm
          formUrl="/formsexamples/rul/forms/number_showcase"
          onSuccess={handleSuccess}
          onError={handleError}
          className="number-showcase-form"
          debounceMs={500}
        />
      </div>
    </div>
  );
};
